import { K3Extensions, K3Main } from '@k3/core'
import Box from '@mui/material/Box'
import { components } from './extensions/components'
import { app } from './extensions/app'
import { extendVariableLabel } from './extensions/extendVariableLabel'
import { additionalDynamicSettings } from './extensions/additionalDynamicSettings'
import { Provider } from 'react-redux'
import { sunovationStore } from './store/sunovationStore'
import { SunovationReduxContext } from './store/sunovationHooks'

const extensions: K3Extensions = {
  components,
  app,
  extendVariableLabel,
}

export const App = () => {
  return (
    <Provider store={sunovationStore} context={SunovationReduxContext}>
      <Box height={window.innerHeight} width={'100vw'} component={'div'}>
        <K3Main
          extensions={extensions}
          additionalDynamicSettings={additionalDynamicSettings}
        />
      </Box>
    </Provider>
  )
}

export default App
